export default "__VITE_ASSET__0a5957dc__"